import {
  IStandardFieldSetting,
  StandardFieldCode,
} from "../@types/StandardField";

// EN-5192: the configurable built-in fields, in the order the Add Patient form renders them.
// First name, last name and email are absent on purpose — they are always mandatory.
export const STANDARD_FIELD_CODES: StandardFieldCode[] = [
  "HospitalPatientId",
  "DateOfBirth",
  "Sex",
  "Ethnicity",
  "Height",
  "PhoneNumber",
];

// What applies before the settings have loaded, and when the request fails: every field shown,
// none mandatory. Matches the server's catalogue default, so the form never blanks a field
// because a request was slow, and never blocks a submit the server would accept.
// Module-level and frozen so consumers can hold it in a dep array safely.
export const STANDARD_FIELD_DEFAULTS: IStandardFieldSetting[] =
  STANDARD_FIELD_CODES.map((code) => ({
    code,
    enabled: true,
    required: false,
  }));

export function isStandardFieldEnabled(
  code: StandardFieldCode,
  settings: IStandardFieldSetting[] | undefined
): boolean {
  if (!settings) return true;
  const setting = settings.find((field) => field.code === code);
  // An unknown code means a server that has not shipped this field yet — show it rather than
  // hiding a field the form has always had.
  return setting ? setting.enabled : true;
}

export function isStandardFieldRequired(
  code: StandardFieldCode,
  settings: IStandardFieldSetting[] | undefined
): boolean {
  if (!settings) return false;
  const setting = settings.find((field) => field.code === code);
  return setting ? setting.enabled && setting.required : false;
}

// The " *" suffix the form appends to a label. Kept here so every field derives it the same way
// instead of hard-coding the asterisk.
export function requiredMarker(isRequired: boolean): string {
  return isRequired ? " *" : "";
}
